exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".board-card {\n    width: 100%;\n}\n\n.board-card a {\n    text-decoration: none;\n    color: rgba(0, 0, 0, 1);\n}", ""]);

